import Menu from '../../menus/model/Menu';
import MenuIcon from '../../menus/model/MenuIcon';
import BannerTranslation from './BannerTranslation';
export default class Banner {
    constructor(menus) {
        const { id, status, sort, page, desktop_image, mobile_image, vertical_position_desktop, horizontal_position_desktop, vertical_position_mobile, horizontal_position_mobile, button_image, show_button, only_title, button_pdf, translations } = menus;
        this.id = id;
        this.status = status;
        this.sort = sort;
        this.page = page ? new Menu(page) : undefined;
        this.desktop_image = desktop_image ? new MenuIcon(desktop_image) : undefined;
        this.mobile_image = mobile_image ? new MenuIcon(mobile_image) : undefined;
        this.vertical_position_desktop = vertical_position_desktop;
        this.horizontal_position_desktop = horizontal_position_desktop;
        this.vertical_position_mobile = vertical_position_mobile;
        this.horizontal_position_mobile = horizontal_position_mobile;
        this.button_image = button_image ? new MenuIcon(button_image) : undefined;
        this.show_button = show_button;
        this.button_pdf = button_pdf;
        this.only_title = only_title;
        this.translations = translations.map(translation => new BannerTranslation(translation));
    }
}
